module.exports = __webpack_public_path__ + "static/media/img117.5b730591.jpg";